import qFetch from "@qnpm/react-native-ext-fetch-web";

function getQpVersionFail(hybridId, e) {
    GodEye && GodEye.log({
        r: 'get_qp_info_fail',
        error: e && JSON.stringify(e),
        message: e && e.errmsg,
        hybrid_id: hybridId
    })
}

function getQpVersionTotal(hybridId) {
    GodEye && GodEye.log({
        r: 'get_qp_info_version',
        hybrid_id: hybridId
    })
}

function encrypt(word) {
    if (window && window.CryptoJS) {
        const key = CryptoJS.enc.Utf8.parse('1234123412ABCDEF'); // 十六位十六进制数作为密钥
        const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); // 十六位十六进制数作为密钥偏移量
        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        let res = encrypted.ciphertext.toString().toUpperCase();
        return `QEncode_${res}`;
    }
}

export default async (options) => {
    const {url, method = 'POST', requestType = 'json', body, timeout} = options || {};
    const { t } = body || {};

    let appInfo = {};
    if(window.appInfoService){
        appInfo = await window.appInfoService.getInfo({
            getQpVersionFail,
            getQpVersionTotal
        });

        if(t === 'f_urInfo_lowPriceFlight_filter' && window && window.CryptoJS) {
            appInfo.uid = encrypt(appInfo.uid)
            appInfo.adid = encrypt(appInfo.adid)
        }

    } else {
        console.warn('appInfoService is not provided')
    }

    return qFetch({
        url: url,
        method: method,
        requestType: requestType,
        timeout: timeout,
        body: {
            b: body,
            c: appInfo
        }
    })
};
